import { PickNChooseHeader } from '@intigral/shared';
import f from '../../../helpers/formatter';
import { __ } from '../../../translations';
import { IComponentHeaderProps } from '../types/iPickAndChooseHeader';
import { getDefaultServiceCollectionDetails } from '@intigral/utils';
import { useAllSubscriptionTier } from '../hooks/useAllSubscriptionTier';
import { IPlanConfigV2 } from '@intigral/domain/lib/entity/interface/iEntitlements';

const PickAndChooseHeader: React.FC<IComponentHeaderProps> = ({ carousel, meta }) => {
    const { data } = useAllSubscriptionTier();
    const deaultServiceCollectionDetail = getDefaultServiceCollectionDetails(
        (data?.planConfig as IPlanConfigV2)?.serviceCollectionDetails || []
    );
    if (deaultServiceCollectionDetail == null || deaultServiceCollectionDetail?.freeAddOnsCount == 0) {
        return null;
    }
    return (
        <div id={carousel?.id} data-test-id={carousel?.id}>
            <PickNChooseHeader
                heading={f.getComponentTitle(meta)}
                description={[
                    __('pick_and_choose_complimantry_text', {
                        freeAddOnsCount: deaultServiceCollectionDetail?.freeAddOnsCount || 0,
                    }),
                ]}
            />
        </div>
    );
};

export default PickAndChooseHeader;
